import adapter from 'garaje/utils/decorators/adapter';

import SignInFieldModel from './sign-in-field';

@adapter('entry-sign-in-field')
class EntrySignInField extends SignInFieldModel {
  // Inherits all properties and relationships from SignInFieldModel
}

export default EntrySignInField;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'entry-sign-in-field': EntrySignInField;
  }
}
